import { ClueCard } from '@snapi/luxury';
import Image from 'next/image';
import EvolutionImage from './images/evolution-illustration.png';
import EvolutionImageSmall from './images/evolution-illustration-little-version.png';
import RedCircle from './images/red-circle.png';

interface EvolutionPhaseCardProps {
  title: string;
  children: React.ReactNode;
}

function EvolutionPhaseCard({ title, children }: EvolutionPhaseCardProps) {
  return (
    <div className="md:flex-col md:w-[206px] lg:w-[290px] xl:w-[380px]">
      <h5 className="uppercase mb-2">{title}</h5>
      <p className="text-body">{children}</p>
    </div>
  );
}

export function EvolutionSectionScience() {
  return (
    <section id="evolution-section-science" className="relative">
      <div className="hidden sm:block sm:absolute top-0 left-0 w-[90px] md:top-[40px] md:w-[100px] lg:w-[160px] lg:top-[-20px]">
        <Image src={RedCircle} alt="" />
      </div>
      <div className="px-4 sm:px-10 relative container overflow-hidden">
        <div className="relative flex justify-center">
          <h2 className=" relative flex w-[274px] text-[28px] sm:w-[366px] md:text-[32px] md:w-[336px] lg:w-[650px] text-center mb-3">
            How will my baby’s microbiome evolve?
            <div
              className="absolute w-[200px] font-mono text-body font-normal sm:w-[226px] bottom-[2px] right-[-40px] text-[24px] 
              sm:right-[-100px] md:right-[-140px]"
            >
              <ClueCard
                description="Temporal development of the gut microbiome in early childhood from the TEDDY study."
                href="https://www.nature.com/articles/s41586-018-0617-x"
                orientation="bottom"
              />
            </div>
          </h2>
        </div>

        <p className="text-center mb-10 sm:w-[454px] md:w-[482px] mx-auto text-body">
          The first 1000 days of life are a window of opportunity to shape the gut 
          microbiome. The decisions you make for your baby during this time play a 
          crucial role in the healthy growth and development of your baby.
        </p>
        <div>
          <div className="hidden sm:block min-w-[290px] max-w-[950px] mb-10 mx-auto">
            <Image src={EvolutionImage} alt="" />
          </div>
          <div className="sm:hidden">
            <Image src={EvolutionImageSmall} alt="" />
          </div>
        </div>
        <div className="flex flex-col gap-y-10 md:flex-row md:gap-8 md:justify-center xl:gap-12">
          <EvolutionPhaseCard title="Developmental phase">
            Months 3-14 are when gradual changes in the abundance of microbes
            occur as a result of new foods and different environmental
            exposures.
          </EvolutionPhaseCard>
          <EvolutionPhaseCard title="transitional phase">
            Months 15-20 focus on the development of key bacteria, which is 
            determined by age as well as food and environmental exposures.
          </EvolutionPhaseCard>

          <EvolutionPhaseCard title="stable phase">
            Months 30+ is when the microbiome reaches its full maturity. 
            This stage sets the foundation for lifelong health related to 
            the gut microbiome.
          </EvolutionPhaseCard>
        </div>
      </div>
    </section>
  );
}
